export default "__VITE_ASSET__DqvM4UmU__"